export const getDisplayListingStatus = listingStatus => {
    switch (listingStatus) {
        case 'SALE':
            return 'Sale';
        case 'LEASE':
            return 'Lease';
        case 'SUBLEASE':
            return 'Sublease';
        default:
            return listingStatus;
    }
};

export const getDisplaySize = size => {
    switch (size) {
        case 'gt10':
        case '_GT10':
            return '10,000 sq/ft+';
        case '5to10':
        case '_5TO10':
            return '5,000 - 9,999 sq/ft';
        case '1to5':
        case '_1TO5':
            return '1,000 - 4,999 sq/ft';
        case '0to1':
        case '_0TO1':
            return '0 - 999 sq/ft';
        default:
            return '';
    }
};

export const getDisplayPurpose = purpose => {
    switch (purpose) {
        case 'restaurant':
        case 'RESTAURANT':
            return 'Restaurant Space';
        case 'retail':
        case 'RETAIL':
            return 'Traditional Retail Space';
        case 'other':
        case 'OTHER':
            return 'Other Service';
        case 'distribution':
        case 'DISTRIBUTION':
            return 'Distribution Space';
        default:
            return '';
    }
};

export const getDisplayDensity = density => {
    switch (density) {
        case 'suburban':
        case 'SUBURBAN':
            return 'Suburban';
        case 'urban':
        case 'URBAN':
            return 'Urban';
        case 'rural':
        case 'RURAL':
            return 'Rural';
        default:
            return '';
    }
};

export const getDisplayCenter = center => {
    switch (center) {
        case 'mall':
        case 'MALL':
            return 'Mall';
        case 'power':
        case 'POWER':
            return 'Power';
        case 'specialty':
        case 'SPECIALTY':
            return 'Specialty/Lifestyle';
        case 'community':
        case 'COMMUNITY':
            return 'Community/Neighborhood';
        case 'strip':
        case 'STRIP':
            return 'Strip Center/Convenient Center';
        case 'outlet':
        case 'OUTLET':
            return 'Outlet Center';
        case 'mixed':
        case 'MIXED':
            return 'Mixed Use';
        case 'other':
        case 'OTHER':
            return 'Other';
        case 'none':
        case 'NONE':
            return 'None';
        default:
            return '';
    }
};

export const getDisplayFacility = facility => {
    switch (facility) {
        case 'inline':
        case 'INLINE':
            return 'In-Line';
        case 'endcap':
        case 'ENDCAP':
            return 'End Cap';
        case 'freestanding':
        case 'FREESTANDING':
            return 'Freestanding';
        default:
            return '';
    }
};
